import { IProductList } from "@command-center-app/index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VendorOfferingsState {
  offerings: IProductList[];
  loading: boolean;
  error: string | null;
  selectedOffering: IProductList | null;
}

const initialState: VendorOfferingsState = {
  offerings: [],
  loading: false,
  error: null,
  selectedOffering: null,
};

const vendorOfferingsSlice = createSlice({
  name: "vendorOfferings",
  initialState,
  reducers: {
    fetchVendorOfferingsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVendorOfferingsSuccess(state, action: PayloadAction<IProductList[]>) {
      state.loading = false;
      state.offerings = action.payload;
    },
    fetchVendorOfferingsFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedOffering(state, action: PayloadAction<IProductList | null>) {
      state.selectedOffering = action.payload;
    },
  },
});

export const {
  fetchVendorOfferingsRequest,
  fetchVendorOfferingsSuccess,
  fetchVendorOfferingsFailed,
  setSelectedOffering,
} = vendorOfferingsSlice.actions;

export default vendorOfferingsSlice.reducer;
